import { render, staticRenderFns } from "./ListDirectBanking.vue?vue&type=template&id=1efb54db"
import script from "./ListDirectBanking.vue?vue&type=script&lang=js"
export * from "./ListDirectBanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports